import React, { useEffect, useState } from "react";
import * as Logger from 'loglevel';
import { Switch, Route, Redirect } from 'react-router-dom'

import Story from '../main-content/arrivalboard/Story'
import Users from '../main-content/admin/Users'
import ProductionCenter from '../main-content/admin/ProductionCenter'
import About from '../main-content/admin/About'
import MyAccount from '../main-content/admin/MyAccount'
import Hub from '../main-content/admin/Hub/Hub'

import FormSelector from '../../widgets/FormSelector';
import { HubForm } from 'hub-dashboard-framework'
import * as HubConstant from "util/HubConstant"
import { UtilConstant } from 'hub-utilities'
import authService from '../../api-authorization/AuthorizeService';

import MetricsReports from '../main-content/arrivalboard/MetricsReports/MetricsReports'

import '../../../styles/sections/MainContent.scss';

export function MainContent(props) {
    const [formDescriptor, setFormDescriptor] = useState(null);

    const onOpenForm = (formType, objectType, formObject) => {
        Logger.debug(formType)
        Logger.debug(objectType)
        Logger.debug(formObject)
        let formDesc = FormSelector.selectForm(formType, formObject);
        Logger.debug(formDesc);
        if (!!formDesc) {
            setFormDescriptor(formDesc)
        }
    }

    const onFormClosed = () => {
        setFormDescriptor(null)
    }

    Logger.debug(props);
    return (
        <div className="MainContent">
            <HubForm {...props} formDesc={formDescriptor} onFormClosed={onFormClosed} onFormSubmitted={onFormClosed} arrOfNewData={props.arrOfNewData} round />
            
            <Switch>
                <Redirect exact from='/' to='/newsfeed' />
                <Route path='/newsfeed' render={(routeProps) => <Story {...routeProps}
                    activePageName={props.activePageName} setActivePageName={props.setActivePageName} onOpenForm={onOpenForm} objectType={HubConstant.HUB_OBJECT_STORY}
                    clickNotifier={props.clickNotifier} arrOfNewData={props.arrOfNewData} setArrOfNewData={props.setArrOfNewData} isNotificationAllowed={props.isNotificationAllowed} setIsNotificationAllowed={props.setIsNotificationAllowed} />} />
                <Route path='/account' render={(routeProps) => <MyAccount {...routeProps} activePageName={props.activePageName} setActivePageName={props.setActivePageName} />} />
                <Route path='/usage_metrics' render={(routeProps) => <MetricsReports {...routeProps} hubInfo={authService.getHubInfo()} activePageName={props.activePageName} setActivePageName={props.setActivePageName} />} />
                <Route path='/about' render={(routeProps) => <About {...routeProps} activePageName={props.activePageName} setActivePageName={props.setActivePageName} />} />
                {
                    authService.getUserType() !== UtilConstant.HUB_USER_TYPE.HUB_USER ?
                        <>
                            <Route path='/users' render={(routeProps) => <Users {...routeProps} activePageName={props.activePageName} setActivePageName={props.setActivePageName} onOpenForm={onOpenForm} objectType={HubConstant.HUB_USERS} />} />
                            <Route path='/pdcenter' render={(routeProps) => <ProductionCenter {...routeProps} isForm={false} activePageName={props.activePageName} setActivePageName={props.setActivePageName} onOpenForm={onOpenForm} />} />
                            {
                                authService.getUserType() === UtilConstant.HUB_USER_TYPE.HUB_ADMIN ?
                                    <Route path='/hub' render={(routeProps) => <Hub {...routeProps} activePageName={props.activePageName} setActivePageName={props.setActivePageName} objectType={HubConstant.HUB_PRODUCTION_GROUP} onOpenForm={onOpenForm} />} onFormClosed={onFormClosed} />
                                    : <></>
                            }
                        </>
                        : <></>
                }
            </Switch>
        </div>
    );
}

export default MainContent
